import {INVOICE_TC, INVOICE_TC_UPSERT, 
  PAYRPT_TC, PAY_TC_UPSERT, RPT_TC_UPSERT,
  CLEAR_TEMP_DC, CLEAR_DC, ProForma_TC, ProForma_TC_UPSERT, PAYMENT_TC} from '../../../../Helper/actionsTypes';

const dcReducer = (state={}, action) => {
  switch (action.type) {
    case INVOICE_TC:{
      return action.payload.code === 200
        ? {...state, itc: action.payload.results[0]}
        : {...state, itc: {}};
    }
    case PAYRPT_TC:{
      return action.payload.code === 200
        ? {...state, payrpt: action.payload.results[0]}
        : {...state, payrpt: {}};
    }
    case PAYMENT_TC:{
      return action.payload.code === 200
        ? {...state, payment: action.payload.results[0]}
        : {...state, payment: {}};
    }
    case INVOICE_TC_UPSERT:{
      return action.payload.code === 200
        ? {...state, itemSaved: true}
        : {...state, itemSaved: false};
    }
    case PAY_TC_UPSERT:{
      return action.payload.code === 200
        ? {...state, paymentSaved: true}
        : {...state, paymentSaved: false};
    }
    case RPT_TC_UPSERT:{
      return action.payload.code === 200
        ? {...state, rptSaved: true}
        : {...state, rptSaved: false};
    }
    case ProForma_TC :{
      return action.payload.code === 200
      ? {...state, proforma: action.payload.results[0]}
      : {...state, proforma: {}};  
      }
      case ProForma_TC_UPSERT:{
        return action.payload.code === 200
          ? {...state, proFormaSaved: true}
          : {...state, proFormaSaved: false};
      }
    case CLEAR_TEMP_DC:{
      return {...state, itemSaved: null, paySaved: null, rptSaved: null,proFormaSaved:null, paymentSaved:null};
    }
    case CLEAR_DC: return {};
    default: return state;
  }
};

export default dcReducer;